module.exports = __webpack_public_path__ + "static/media/average_star_A.ed302595.png";